import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { UseAuthContext } from '../../context/AuthContext';
import { auth } from '../../firebase';

export default function Header() {
    const [menu, setMenu] = useState(false);
    const { user } = UseAuthContext();

    return (
        <header id="header" className="fixed-top d-flex align-items-center">
            <div className="container d-flex align-items-center justify-content-between">
                <div className="logo">
                    <h1 className="text-light"><Link to="/"><span>Solution Points</span></Link></h1>
                </div>
                <nav id="navbar" className={menu ? "navbar navbar-mobile" : "navbar"}>
                    <ul>
                        <li><NavLink  to="/" activeClassName="nav-link scrollto active" onClick={() => setMenu(false)}>Home</NavLink></li>
                        <li><NavLink  to="/tutor" activeClassName="nav-link scrollto active" onClick={() => setMenu(false)}>Tutor</NavLink></li>
                        <li><NavLink  to="/mess" activeClassName="nav-link scrollto active" onClick={() => setMenu(false)}>Mess/Flat</NavLink></li>
                        <li><NavLink  to="/contact" activeClassName="nav-link scrollto active" onClick={() => setMenu(false)}>Contact</NavLink></li>
                        {user && <li><NavLink  to="/account" activeClassName="nav-link scrollto active" onClick={() => setMenu(false)}>{user.name}</NavLink></li>}
                        <li><NavLink  to={user ? "/" : "/login"} className="getstarted" style={{ color: "#fff" }} onClick={() => { setMenu(false); auth.signOut() }}>{user ? "Sign Out" : "Sign In"}</NavLink></li>
                    </ul>
                    <i className={menu ? "bi mobile-nav-toggle bi-x" : "bi bi-list mobile-nav-toggle"} onClick={() => setMenu(!menu)} />
                </nav>
            </div>
        </header>

    );
}